import { useState } from "react";
import { Button, Col, Form, Row } from "react-bootstrap";
import { ICountry, IForgotState, Recovery } from "../../../utils/types";
import { useTranslation } from "react-i18next";
import "../stylePage.css";
import ModalSmall from "../../components/ModalSmall";
import { ForgotPassword } from "../../../services/UserAuthService"; 

 
const ForgotPasswordForm = ({
  countries,
  forgotState,
}: {
  countries: ICountry[];
  forgotState: IForgotState;
}) => {
  const { t } = useTranslation();

  const [loading, setLoading] = useState<boolean>(false);
  const [recovery, setRecovery] = useState<Recovery>({ email: "" } as Recovery);
 
  const [error, setError] = useState<boolean>(false);
  const [msgError, setMsgError] = useState<string>("");
  const [info, setInfo] = useState<boolean>(false);
  const [msgInfo, setMsgInfo] = useState<string>("");
  const [selectedValueCountry, setSelectedValueCountry] = useState<number>(1);

  async function handleSend() {
    setLoading(true);
    setMsgError("");
    setMsgInfo("");
    try {
      let country = countries.find(
        (country) => country.CountryID === recovery.countryID
      );
      const response = await ForgotPassword(
        recovery.email,
        recovery.countryID ?? country?.CountryID ?? 0,
        t("locale")
      );  
      if (response?.data?.Code > 0) {
        setMsgInfo(response.data?.Message?.ErrorMessage);
        setInfo(true);
        recovery.email = "";  
      }  
      setTimeout(() =>  forgotState.setClickedForgot(false), 5000);    
    } catch (error) { 
      setMsgInfo(t("password.submit.errorTitle"));
      setInfo(true);
    } finally {
      setLoading(false);
    }
  }

  function handleCancel() {
    recovery.email = "";
    forgotState.setClickedForgot(false);
  }

  return (
    <>
      <Col className="forgotDiv">
        <fieldset className="loginFieldset">
          <legend className="loginFieldsetLegend">
            {t("password.forgotPasswordTitle")}
          </legend>
          <Row>
            <div>
              <input
                className="loginInput"
                placeholder={t("password.email")}
                value={recovery.email}
                onChange={(e) =>
                  setRecovery((prev) => ({ ...prev, email: e.target.value }))
                }
              />
            </div>
          </Row>
          <Row>
            <Col sm={5}>
              <Form.Select
                size="sm"
                onChange={(e) => {  
                  setRecovery((prev) => ({
                    ...prev,
                    countryID: parseInt(e.target.value),
                  }));
                  setSelectedValueCountry(parseInt(e.target.value)); 
                }}
                defaultValue={selectedValueCountry}
                value={selectedValueCountry} 
              >
                {countries.map((option) => (
                  <option key={option.CountryID} value={option.CountryID}>
                    {option.CountryDesc}
                  </option>
                ))}
              </Form.Select>
            </Col>
          </Row>
          <Row>
            <Col>
              <Button
                className="button"
                onClick={handleSend}
                disabled={loading}
              >
                {t("password.submit.send")}
              </Button>
            </Col>
            <Col>
              <Button
                className="button"
                onClick={handleCancel}
                disabled={loading}
              >
                {t("password.cancel")}
              </Button>
            </Col>
          </Row>
        </fieldset>
      </Col>
      <ModalSmall
        showModal={error}
        setShowModal={setError}
        title={t("password.submit.errorTitle")}
        text={msgError}
        type="modal-danger"
      />
      <ModalSmall
        showModal={info}
        setShowModal={setInfo}
        title={t("password.submit.WarnTitle")}
        text={msgInfo}
        type="modal-warn"
      />
    </>
  );
};

export default ForgotPasswordForm;
